import { createContext } from 'react';
export const FieldContext=createContext<{id:string;error?:boolean;disabled?:boolean;required?:boolean}|null>(null);
